export class ClientNegativeBalanceReport {
  negative_balance_sum: number = 0;
}
